import { Component, ViewChild, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter  } from '@angular/core';
import GatewayDto  from '../../dto/gateway-dto';

@Component({
  selector: 'gateway-describe-step',
  template: require('./gateway-describe-step.html')
})

export default class GatewayDescribeStep {
    @Input('gateway') gateway: GatewayDto;
    @Input('isEditMode') isEditMode: boolean;
    @Output('onFormValid') formValid = new EventEmitter();
    @ViewChild('describeGatewayForm') form;

    haStatus: string;
    constructor() {

    }

    ngOnChanges(chnage: SimpleChanges){
      if(this.isEditMode){
        this.updateHAStatus();
      }
    }
    changeHighAvailability(event) {
        this.gateway.haSettings.enabled = !this.gateway.haSettings.enabled;
        this.updateHAStatus();
    }

    updateHAStatus() {
        this.haStatus = this.gateway.haSettings.enabled ? 'Activated' : 'Deactivated';
    }

    ngAfterViewInit(){
      this.form.control.valueChanges
      .subscribe(values => this.isFormValid(values));
    }

    isFormValid(values) {
       this.formValid.emit(
           {
             'isValid': this.form.valid
           }
         );
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-describe-step.component.ts